<template>
</template>
<script>
  export default {
    mounted() {
      window.print()
    }
  }
</script>
